import type { ReactNode } from 'react';
import { DS2 } from '../theme/designTokens';

const TOKEN_RE = /(\*\*[^*\n]+\*\*)|(_[^_\n]+_)|(\+\+[^+\n]+\+\+)|(https?:\/\/[^\s<]+)|(#[a-zA-Z0-9_]+)/g;

export function renderFormattedMessage(text: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;
  let match: RegExpExecArray | null;
  TOKEN_RE.lastIndex = 0;

  while ((match = TOKEN_RE.exec(text)) !== null) {
    if (match.index > lastIndex) nodes.push(text.slice(lastIndex, match.index));

    const [full, bold, italic, underline, url, hashtag] = match;
    if (bold) {
      nodes.push(<strong key={key++}>{bold.slice(2, -2)}</strong>);
    } else if (italic) {
      nodes.push(<em key={key++}>{italic.slice(1, -1)}</em>);
    } else if (underline) {
      nodes.push(<u key={key++}>{underline.slice(2, -2)}</u>);
    } else if (url) {
      nodes.push(
        <a
          key={key++}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: DS2.color.gold, textDecoration: 'underline' }}
        >
          {url}
        </a>
      );
    } else if (hashtag) {
      nodes.push(
        <span key={key++} style={{ color: DS2.color.gold, fontWeight: 600 }}>
          {hashtag}
        </span>
      );
    } else {
      nodes.push(full);
    }

    lastIndex = TOKEN_RE.lastIndex;
  }

  if (lastIndex < text.length) nodes.push(text.slice(lastIndex));
  return nodes;
}
